<template>
  <div ref="root"
       :class="'w-100 base-grid container-fluid no-gutters p-0 m-0' + (editOn ? ' edit-on' : '')"
       @wheel.stop="viewScroll"
       data-test-path="base-grid"
       :data-test-path-fixed="(form != null) ? 'base-grid-' + form.formClass : 'base-grid'"
       style="height: 100%;"
       @touchstart="onTouchStart"
       @touchmove="onTouchMove">


    <div ref="dataBody"
         data-test-path="data-body"
         class="w-100 no-gutters p-0 m-0"
         :style="'overflow:hidden; position:relative; height: 100%;'">

      <!-- <editor-fold defaultstate="collapsed" desc="SCROLLBARS"> -->

      <!-- poziomy __ -->
      <div v-if="hScrollBarVisible"
           ref="hScroll"
           data-test-path="h-scroll"
           class="d-block h-scroll"
           :style="'z-index:2000; position: absolute; bottom: 0;' +
            'opacity:1; left:0; right: 0; overflow-x: auto; overflow-y: hidden;'"
           @scroll="onHScroll">
        <div
            :style="'display:block; visibility: hidden; height: ' + scrollBarHeight + 'px; width: ' + hScrollSize + 'px'"></div>
      </div>

      <!-- pionowy | -->
      <div v-if="vScrollBarVisible"
           data-test-path="v-scroll"
           ref="vScroll"
           class="d-block v-scroll"
           :style="hScrollBarVisible ?
            ('opacity:1; z-index:2000; position: absolute; top:0; bottom: ' + scrollBarHeight + 'px; right:0; overflow-y: auto; overflow-x: hidden'):
             'opacity:1; z-index:2000; position: absolute; top:0; bottom: 0;                         right:0; overflow-y: auto; overflow-x: hidden'"
           @scroll="onVScroll">
        <div
            :style="'display:block; visibility: hidden; width: ' + scrollBarWidth+ 'px; height: ' + (vScrollSize + headerHeight + pinnedBottomHeight)+ 'px'"></div>
      </div>

      <!-- </editor-fold >  -->


      <!-- <editor-fold defaultstate="collapsed" desc="HEADERS"> -->

      <div ref="headerBar"
           data-test-path="header-bar"
           class="bgr-header"
           :style="'z-index:900; overflow:hidden; background-color:#DBE8FF;  position:absolute; top:0; left:0; right:0; height:' + headerHeight + 'px'"
      >
        <div ref="headerBody"
             :style="'padding-left:' + pinnedColumnsWidth +'px; flex-wrap: nowrap; background-color:#DBE8FF; display:flex; align-items:center; white-space: nowrap; width:' + hScrollSize + 'px'">
          <div v-for="col in activeColumns"
               :class="col.sortable ? 'sortable' : ''"
               :style="{
                     flexWrap: 'nowrap',
                     display: 'flex',
                     alignItems: 'center',
                     position: 'relative',
                     backgroundColor: activeColId === col.colId ? '#CBF1D3' : 'transparent'
                 }"
               @click="sortByColClick(col)"
               :key="instanceUid + ':' + col.colId">
            <div ref="headerCell"
                 class="bgr-hdr-cell"
                 :style="{
                     overflow: 'hidden',
                     position: 'relative',
                     paddingLeft:  '10px',
                     maxHeight: 2 * defaultRowHeight + 'px',
                     whiteSpace: 'wrap',
                     display: 'inline-block',
                     width: col.size + 'px'
                 }">
              <div class="d-flex align-items-center">
                <span style="font-weight: 600; user-select: none">{{ truncateName(col, 6) }}</span>
                <b-btn v-if="col.searchable"
                       :data-test-path="'grid-header-query-' + col.name"
                       :style=" {backgroundColor: activeColId === col.colId ? '#CBF1D3' : ''}"
                       class="hdr-button-query" @click.stop="startSearching(col)">
                  <font-awesome-icon :style="{color: activeColId === col.colId ? '#849bc5' : ''}" class="hdr-icon"
                                     icon="magnifying-glass" transform="shrink-3"></font-awesome-icon>
                </b-btn>
              </div>
            </div>
            <div style="position: relative; width: 0px; height: 0px; bottom: 15px;">
              <b-button v-if="col.sortable" :class="{'hdr-button-hover': col === sortByCol}"
                        :style=" {backgroundColor: activeColId === col.colId ? '#CBF1D3' : ''}" class="hdr-button">
                <font-awesome-icon v-if="col.order === 'asc'"
                                   :class="{'hdr-icon-hover': col === sortByCol}"
                                   :style="{color: activeColId === col.colId ? '#849bc5' : ''}" class="hdr-icon"
                                   icon="arrow-up"
                                   transform="shrink-2"></font-awesome-icon>
                <font-awesome-icon v-else-if="col.order === 'desc'"
                                   :class="{'hdr-icon-hover': col === sortByCol}"
                                   :style="{color: activeColId === col.colId ? '#849bc5' : ''}" class="hdr-icon"
                                   icon="arrow-down" transform="shrink-2"></font-awesome-icon>
                <font-awesome-icon v-else :class="{'hdr-icon-hover': col === sortByCol}"
                                   :style="{color: activeColId === col.colId ? '#849bc5' : ''}" class="hdr-icon"
                                   icon="arrow-up-arrow-down"
                                   transform="shrink-2"></font-awesome-icon>
              </b-button>
              <div v-if="eligibleFields">
                <b-button v-if="eligibleFields.some(element=>element.fieldLabel === col.name)"
                          :style=" {backgroundColor: activeColId === col.colId ? '#CBF1D3' : ''}"
                          class="hdr-button-filter" @click.stop="filterByColumn(col)">
                  <font-awesome-icon :style="{color: activeColId === col.colId ? '#849bc5' : ''}" class="hdr-icon"
                                     icon="filter" transform="shrink-2"></font-awesome-icon>
                </b-button>
              </div>

            </div>
            <div class="colSpacer headerSpacer"
                 @click.stop=""
                 @mousedown.stop="colSpacerStartDrag"
                 :data-col-id="col.colId"
                 :style="'z-index:3000; width: 8px; margin-right:-3px; margin-left:-4px; height: ' + headerHeight + 'px; display: flex; justify-content: center;'">
              <div style="width: 1px; height: 100%; background-color: #C6D8F8;"></div>
            </div>
            <div v-if="editOn && col.editorComponent"
                 :style="{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  width: '100%',
                  height: '4px',
                  backgroundColor: 'lightgreen',
                  zIndex: '4000'
                  }">
            </div>
          </div>
        </div>
        <!--        <div v-if="hScrollSize < windowWidth"-->
        <!--             class="empty-column"-->
        <!--             :style="'flex-grow: 1; background-color: #b4c9d4; height: ' + headerHeight + 'px'">-->
        <!--        </div>-->
      </div>

      <div ref="pinnedHeaderBar"
           data-test-path="pinned-header-bar"
           class="bgr-header bgr-header-pinned"
           :style="'z-index:900; overflow:hidden; position:absolute; top:0; left:0; height:' + headerHeight + 'px'"
      >
        <div ref="pinnedHeaderBody"
             data-test-path="pinned-header-body"
             :style="'flex-wrap: nowrap; display:flex; align-items:center; white-space: nowrap;'">
          <div
              v-for="col in activePinnedColumns"
              :style="{
                     flexWrap: 'nowrap',
                     display: 'flex',
                     alignItems: 'center',
                     position: 'relative',
                     backgroundColor: activeColId === col.colId ? '#CBF1D3' : 'transparent'
                 }"
              :key="instanceUid + ':p:' + col.colId"
              :class="col.sortable ? 'sortable' : ''"
              @click="sortByColClick(col)">
            <div ref="headerCellPinned"
                 class="bgr-hdr-cell"
                 :style="{
                     overflow: 'hidden',
                     position: 'relative',
                     paddingLeft: '10px',
                     maxHeight: 2 * defaultRowHeight + 'px',
                     whiteSpace: 'wrap',
                     display: 'inline-block',
                     width: col.size + 'px'
                 }">
              <div class="d-flex align-items-center">
                <span style="font-weight: 600; user-select: none">{{ truncateName(col, 6) }}</span>
                <b-btn
                    v-if="col.searchable"
                    :data-test-path="'grid-header-query-' + col.name"
                    :style=" {backgroundColor: activeColId === col.colId ? '#CBF1D3' : ''}"
                    class="hdr-button-query"
                    @click.stop="startSearching(col)">
                  <font-awesome-icon
                      :style="{color: activeColId === col.colId ? '#849bc5' : ''}"
                      class="hdr-icon"
                      icon="magnifying-glass"
                      transform="shrink-3">
                  </font-awesome-icon>
                </b-btn>
              </div>
            </div>
            <div style="position: relative; width: 0px; height: 0px; bottom: 15px">
              <b-button
                  v-if="col.name !== ''"
                  :class="{'hdr-button-hover': col === sortByCol}"
                  :style=" {backgroundColor: activeColId === col.colId ? '#CBF1D3' : ''}"
                  class="hdr-button">
                <font-awesome-icon v-if="col.order === 'asc'"
                                   :class="{'hdr-icon-hover': col === sortByCol}"
                                   :style="{color: activeColId === col.colId ? '#849bc5' : ''}" class="hdr-icon"
                                   icon="arrow-up"
                                   transform="shrink-2"></font-awesome-icon>
                <font-awesome-icon v-else-if="col.order === 'desc'"
                                   :class="{'hdr-icon-hover': col === sortByCol}"
                                   :style="{color: activeColId === col.colId ? '#849bc5' : ''}" class="hdr-icon"
                                   icon="arrow-down" transform="shrink-2"></font-awesome-icon>
                <font-awesome-icon v-else :class="{'hdr-icon-hover': col === sortByCol}"
                                   :style="{color: activeColId === col.colId ? '#849bc5' : ''}" class="hdr-icon"
                                   icon="arrow-up-arrow-down"

                                   transform="shrink-2"></font-awesome-icon>
              </b-button>

              <div v-if="eligibleFields">
                <b-button v-if="eligibleFields.some(element=>element.fieldLabel === col.name)"
                          :style=" {backgroundColor: activeColId === col.colId ? '#CBF1D3' : ''}"
                          class="hdr-button-filter" @click.stop="filterByColumn(col)">
                  <font-awesome-icon :style="{color: activeColId === col.colId ? '#849bc5' : ''}" class="hdr-icon"
                                     icon="filter" transform="shrink-2"></font-awesome-icon>
                </b-button>
              </div>
            </div>
            <div :class="col.prop === '__meta__' ? '' : 'colSpacer headerSpacer'"
                 @click.stop=""
                 @mousedown.stop="colSpacerStartDrag"
                 :data-col-id="col.colId"
                 :style="'z-index:300000; width: 8px; margin-right:-3px; margin-left:-4px; height: ' + headerHeight + 'px; display: flex; justify-content: center;'">
              <div style="width: 1px; height: 100%; background-color: #C6D8F8;"></div>
            </div>
            <div v-if="editOn && col.editorComponent"
                 :style="{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  width: '100%',
                  height: '4px',
                  backgroundColor: 'lightgreen',
                  zIndex: '4000'
                  }"></div>
          </div>
        </div>
      </div>

      <!-- </editor-fold >  -->

      <!-- <editor-fold defaultstate="collapsed" desc=" UNPINNED DATA"> -->
      <div v-if="loading"
           :style="'overflow:hidden; z-index: 1500; position:absolute; left:0; right:0; bottom:' + scrollBarHeight + 'px; top:' + headerHeight + 'px'"
      >
        <Loading></Loading>
      </div>

      <div ref="unpinnedData"
           data-test-path="unpinned-data"
           :style="'z-index:500; box-shadow:2px 0 5px rgba(0,0,0,0.1); border-right: 1px solid #F2F5F9; overflow:hidden; position:absolute; left:0; right:0;' +
            ' bottom:' + (scrollBarHeight - scrollBarHeight - pinnedBottomHeight) + 'px; top:' + (headerHeight - firstRowHiddenPixels) + 'px'"
      >

        <Section
            ref="unpinnedDataSection"
            v-if="!loading"
            :hasLinkFlag="hasLinkFlag"
            :activeColumns="activeColumns"
            :focusOnIndex="focusOnIndex"
            :hScrollSize="hScrollSize"
            :headerHeight="headerHeight"
            :pinnedColumnsWidth="pinnedColumnsWidth"
            :rowHeight="rowHeight"
            :rows="rows"
            :source="postProcessedSource"
            @focusRow="focusRow"
            @focusedRowLoaded="focusedRowLoaded"
            @rowKeyDown="rowKeyDown"
            @rowDoubleClick="rowDoubleClick"
            @cellFocus="cellFocus"
            :form="form"
        ></Section>

      </div>

      <div ref="pinnedData"
           v-if="!loading"
           data-test-path="pinned-data"
           :style="
            'z-index:500; box-shadow:2px 0 5px rgba(0,0,0,0.1); border-right: 1px solid #F2F5F9; overflow:hidden; position:absolute; left:0; width:' + pinnedColumnsWidth + 'px; ' +
            'bottom:' + (scrollBarHeight - scrollBarHeight) + 'px; top:' + (headerHeight - firstRowHiddenPixels) + 'px'"
      >
        <Section
            ref="pinnedDataSection"
            :activeColumns="activePinnedColumns"
            :focus-on-index="focusOnIndex"
            :hasLinkFlag="hasLinkFlag"
            :hScrollSize="hScrollSize"
            :headerHeight="headerHeight"
            :pinnedColumnsWidth="0"
            :rowHeight="rowHeight"
            :rows="rows"
            :pinned="true"
            :source="postProcessedSource"
            @focusRow="focusRow"
            @focusedRowLoaded="focusedRowLoaded"
            @rowKeyDown="rowKeyDown"
            @rowDoubleClick="rowDoubleClick"
            @cellFocus="cellFocusPinned"
            :form="form"
        ></Section>
      </div>

      <div ref="unpinnedSummaryRow"
           v-if="pinnedBottomSource.length > 0 && showSummary"
           data-test-path="unpinned-summary-row-data"
           :style="'z-index:500; box-shadow:2px 0 5px rgba(0,0,0,0.1); border-right: 1px solid #F2F5F9; overflow:hidden; position:absolute; left:0; right:0; height:'+pinnedBottomHeight + 'px; bottom:' + (scrollBarHeight) + 'px'"
      >
        <Section
            ref="unpinnedSummaryRowDataSection"
            v-if="!loading"
            :hasLinkFlag="hasLinkFlag"
            :activeColumns="activeColumns"
            :hScrollSize="hScrollSize"
            :headerHeight=0
            :pinnedColumnsWidth="pinnedColumnsWidth"
            :rowHeight="rowHeight"
            :rows="activePinedBottomSourceRows"
            :source="pinnedBottomSource"
            :form="form"
        ></Section>
      </div>

      <div ref="pinnedSummaryRow"
           v-if="!loading && pinnedBottomSource.length > 0 && showSummary"
           data-test-path="pinned-summary-row-data"
           :style="'z-index:500; box-shadow:2px 0 5px rgba(0,0,0,0.1); border-right: 1px solid #F2F5F9; overflow:hidden; position:absolute; left:0; width:' + pinnedColumnsWidth + 'px; height:'+pinnedBottomHeight + 'px; bottom:' + (scrollBarHeight) + 'px'"
      >
        <Section
            ref="pinnedSummaryRowDataSection"
            :activeColumns="activePinnedColumns"
            :hScrollSize="hScrollSize"
            :hasLinkFlag="hasLinkFlag"
            :headerHeight="headerHeight"
            :pinnedColumnsWidth="0"
            :rowHeight="rowHeight"
            :rows="activePinedBottomSourceRows"
            :source="pinnedBottomSource"
            :pinned="true"
            :form="form"
        ></Section>
      </div>
      <!-- </editor-fold >  -->


    </div>
  </div>
</template>
<style>
div.headerSpacer {
  cursor: ew-resize;
}
</style>
<script>

import {DEBUG, getScrollbarSize, sortSource} from "@/components/baseGrid/GridTools";
import Section from "@/components/baseGrid/Section.vue";
import Loading from "@/components/layout/Loading.vue";
import ActivityManager from "@/activity/ActivityManager";
import {nextTick} from "@/utils/Executors";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import FormsLoader from "@/components/forms/FormsLoader";
import filterRenderers from "@/components/forms/renderers/FilterRenderers";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";


let nextUid = 1;
let instanceUid = 1;
const NO_COMPARATOR_CLASS = "com.silkplm.engine.forms.schema.definition.defaults.NoComparator";

export default {
  name: "BaseGrid",
  components: {Loading, Section},

  async created() {
    const {width, height} = getScrollbarSize();
    this.scrollBarWidth = width;
    this.scrollBarHeight = height;

    this.initSizesScheduled = false;
    this.updateSourcesScheduled = false;

    this.resizeObserver = new ResizeObserver(entries => {
      //Tutaj dać warunek żeby jeśli resizing to false
      if (this.frozen) {
        return;
      }

      if (this.recoverSizeAfterFreeze) {
        this.recoverSizeAfterFreeze = false;
      }
      this.$nextTick(() => //requestAnimationFrame(() =>
              setTimeout(() => {
                this.onResize(entries);
              })
          //)
      );
    });
    // window['_v2_grid'] = this;
  },

  async mounted() {
    this.observed = this.$refs.headerBody;
    this.resizeObserver.observe(this.$refs.headerBody);
    this.resizeObserver.observe(this.$refs.pinnedHeaderBody);
    this.initSizes();
    this.updateSources();
    this.$nextTick(() => {
      this.activity = ActivityManager.findActivity(this.$el);
      if (this.activity) {
        this.activity.onHideCallback(() => this.onFreeze());
        this.activity.onShowCallback(() => this.onUnfreeze());
      }
    })
  },

  beforeDestroy() {
    this.resizeObserver.unobserve(this.observed);
    this.resizeObserver.disconnect();
    this.resizeObserver = null;
  },

  methods: {
    onResize(entries) {
      DEBUG && console.log("Resize event detected");
      for (let entry of entries) {
        if (entry.target === this.$refs.headerBody || entry.target === this.$refs.pinnedHeaderBody) {
          const {width, height} = entry.contentRect;
          DEBUG && console.log(`Header body resize - Width: ${width}px, Height: ${height}px`);
          let maxH = 0;
          this.$refs.headerCell?.forEach(cell => {
            if (cell.offsetHeight > maxH) {
              maxH = cell.offsetHeight;
            }
          });
          this.$refs.headerCellPinned?.forEach(cell => {
            if (cell.offsetHeight > maxH) {
              maxH = cell.offsetHeight;
            }
          });
          if (maxH < this.defaultRowHeight) {
            maxH = this.defaultRowHeight;
          }
          if (maxH > 4 * this.defaultRowHeight) {
            maxH = 4 * this.defaultRowHeight;
          }

          this.headerHeight = maxH * 1.2;
          this.scheduleInitSize();
        } else if (entry.target === this.$refs.unpinnedData) {
          const {width, height} = entry.contentRect;
          DEBUG && console.log(`Data body resize - Width: ${width}px, Height: ${height}px`);
          this.scheduleUpdateSource();
        }
      }

      setTimeout(() => {
        if (this.preFreezfocus != null && this.preFreezfocus !== this.focusOnIndex) {
          let offset = this.focusOnIndex;
          this.preFreezfocus = null;
          this.$emit("rowSelected", {data: this.postProcessedSource[offset], index: offset});
          this.fixSelectedRowVisibility();
        }
      });
    },
    refreshRowClasses() {
      for (let row of this.rows) {
        row.cssClass = " " + (this.postProcessedSource[row.index]?.__row_conf?.cssClass ?? "");
      }
    },

    startSearching(col) {
      if (this.activeColId !== col.colId) {
        this.$emit("activateCol", col.colId);
        this.$emit("searchOn", col);
      } else {
        this.$emit("noActiveCol");
        this.$emit("searchOff");
      }
    },
    refreshView(preserveSelection = true) {
      if (this.isRefreshingView) {
        return;
      }
      this.isRefreshingView = true;

      this.calcVScrollSize();
      let maxIndex = this.source.length - 1;
      let needShift = false;
      for (let row of this.rows) {
        if (row.index > maxIndex) {
          needShift = true;
        }
      }
      if (needShift) {
        if (this.source.length <= this.rows.length) {
          this.updateSources();
          this.isRefreshingView = false;
          return;
        }
        let flexOrder = this.rows.length;
        let idx = maxIndex;
        for (let row of this.rows) {
          row.index = idx--;
          row.flexOrder = flexOrder--;
          row.data = this.postProcessedSource[row.index];
          row.cssClass = " " + (row.data?.__row_conf?.cssClass ?? "")
        }
        this.$nextTick(() => {
          this.$refs?.pinnedDataSection?.refreshView();
          this.$refs?.unpinnedDataSection?.refreshView();
        });
        this.isRefreshingView = false;
        return;
      }

      let requiredRenderers = Math.ceil(this.$refs.unpinnedData.offsetHeight / this.rowHeight) + 1;
      this.calcVScrollSize();

      if (requiredRenderers > this.postProcessedSource.length) {
        requiredRenderers = this.postProcessedSource.length;
      }
      DEBUG && console.log(`Reload checkpoint #3; focus: ${this.focusOnIndex}`);

      if (requiredRenderers !== this.rows.length) {
        this.updateSources(preserveSelection);
        this.isRefreshingView = false;
        return;
      }
      this.$refs?.pinnedDataSection?.refreshView();
      this.$refs?.unpinnedDataSection?.refreshView();
      this.isRefreshingView = false;
    },

    checkDataInCells() {
      this.$refs?.pinnedDataSection?.refreshView();
      this.$refs?.unpinnedDataSection?.refreshView();
    },

    async sortByColClick(clickedCol) {
      if (!clickedCol.sortable) {
        return;
      }
      for (let col of this.columns) {
        if (col.order) {
          if (col.prop === clickedCol.prop) {
            clickedCol.order = clickedCol.order === 'asc' ? 'desc' : 'asc';
            this.sortByCol = clickedCol;
            this.sortDirection = clickedCol.order;
            if (clickedCol.dataGrid.streamingEngine) {
              await clickedCol.dataGrid.streamingEngine?.sortBy(clickedCol);
            } else {
              this.sortNonStream(true);
            }
            DEBUG && console.log("To desc: " + col.name)
            this.$emit('orderChange', col);
            return;
          } else {
            DEBUG && console.log("To null: " + col.name);
            col.order = null;
            this.$emit('orderChange', col);
          }
        } else {
          if (col.prop === clickedCol.prop) {
            DEBUG && console.log("New col: " + col.name);
            col.order = 'asc';
            this.$emit('orderChange', col);
          }
        }
      }
      clickedCol.order = 'asc';
      this.sortByCol = clickedCol;
      this.sortDirection = clickedCol.order;
      if (this.sortByCol.dataGrid.streamingEngine) {
        await this.sortByCol.dataGrid.streamingEngine?.sortBy(this.sortByCol);
      } else {
        this.sortNonStream(true);
      }
    },

    async filterByColumn(col) {
      col = this.eligibleFields.filter(element => element.fieldLabel === col.name);
      let result = [];
      let colTable = [];
      let resultToPush = null;

      if (this.form.classIsDynamic) {
        let fieldName = col[0].fieldName;
        let staticField = this.form.fields.filter(f => f.fieldName === fieldName);
        if (staticField) {
          resultToPush = await filterRenderers[col[0].filterRenderer](col[0], this.form, this.context, this);
        } else {
          let dynamicForm = FormsLoader.detectFormConfig(this.form.dynamicCells);
          resultToPush = await filterRenderers[col[0].filterRenderer](col[0], dynamicForm, this.context, this);
        }
      } else {
        resultToPush = await filterRenderers[col[0].filterRenderer](col[0], this.form, this.context, this);
      }
      if (resultToPush && !Array.isArray(resultToPush) || resultToPush && resultToPush.some(item => item !== null)) {
        result.push(resultToPush);
        colTable.push(col[0]);
        if (this.eligibleFields.includes(col)) {
          this.eligibleFields = this.eligibleFields.filter(function (e) {
            return e !== col
          })
        }
      }

      this.$emit('apply-filter', colTable, result);
    },

    sortNonStream(clickedByCol) {
      if (!this.form?.resultComparator) {
        this.postProcessedSource = sortSource(this.source, this.columns);
        return;
      }
      if (!clickedByCol) {
        if (this.form.resultComparator !== NO_COMPARATOR_CLASS) {
          this.postProcessedSource = this.source;
          return;
        }
      }
      this.postProcessedSource = sortSource(this.source, this.columns);
    },
    cellFocus(row, col, event) {
      this.$emit("cellFocus", {index: row.index, data: this.postProcessedSource[row.index]}, col, event);
    },
    cellFocusPinned(row, col, event) {
      this.$emit("cellFocus", {index: row.index, data: this.postProcessedSource[row.index]}, col, event);
    },
    onFreeze() {
      this.state = {
        hScroll: this.$refs.hScroll?.scrollLeft,
        vScroll: this.$refs.vScroll?.scrollTop,
        headerHeight: this.headerHeight
      }
      this.frozen = true;
      this.preFreezfocus = this.focusOnIndex;
      DEBUG && console.log(`Freezing hScroll: ${this.state.hScroll}, vScroll: ${this.state.vScroll}`);
    },
    onUnfreeze() {
      this.frozen = false;
      this.recoverSizeAfterFreeze = true;
      this.$refs?.pinnedDataSection?.forceRequestData();
      this.$refs?.unpinnedDataSection?.forceRequestData();
    },
    focusRow(ev, row) {
      this.focusOnIndex = row.index;
      this.$emit("rowSelected", {data: this.postProcessedSource[row.index], index: row.index});
    },
    focusOnOffset(offset) {
      this.focusOnIndex = offset;
      if (!this.frozen) {
        this.$emit("rowSelected", {data: this.postProcessedSource[offset], index: offset});
        this.fixSelectedRowVisibility();
        this.$nextTick(() => {
          this.$refs?.pinnedDataSection?.forceRequestData();
          this.$refs?.unpinnedDataSection?.forceRequestData();
        });
      }
    },

    truncateName(col, maxLength) {
      if (col.name) {
        if (col.size < 60) {
          return col.name.substring(0, maxLength) + '...';
        }
      }
      return col.name;
    },

    focusedRowLoaded() {
      this.$emit("rowSelected", {data: this.postProcessedSource[this.focusOnIndex], index: this.focusOnIndex});
    },
    updateSelectedRow() {
      const pageSize = Math.ceil(this.$refs.unpinnedData.offsetHeight / this.rowHeight);
      if (this.focusOnIndex < 0) {
        this.focusOnIndex = 0;
      }
      if (this.focusOnIndex > this.postProcessedSource.length - 1) {
        this.focusOnIndex = this.postProcessedSource.length - 1;
      }

      this.fixSelectedRowVisibility();
      this.$nextTick(() => {
        this.$emit("rowSelected", {
          data: this.postProcessedSource[this.focusOnIndex],
          index: this.focusOnIndex
        })
      });
    },
    findMinRowIndex() {
      let min = -1;
      for (let row of this.rows) {
        if (min === -1 || (row.index < min && row.index >= 0)) {
          min = row.index;
        }
      }

      return min < 0 ? 0 : min;
    },
    rowKeyDown(ev) {
      if (ev.key === "ArrowDown") {
        if (this.focusOnIndex === -1) {
          this.focusOnIndex = 0;
          this.updateSelectedRow();
          return;
        }
        if (ev.shiftKey) {

        }
        this.focusOnIndex++;
        this.updateSelectedRow();
        return;
      }

      if (ev.key === "ArrowUp") {
        if (this.focusOnIndex === -1) {
          this.focusOnIndex = 0;
          this.updateSelectedRow();
          return;
        }

        if (ev.shiftKey) {

        }
        this.focusOnIndex--;
        this.updateSelectedRow();
        return;
      }

      if (ev.key === "ArrowLeft") {

        const scrollLeft = this.$refs.unpinnedData.scrollLeft;
        const pinnedAreaWidth = this.pinnedColumnsWidth;

        let ctr = 0;

        let firstVisibleColI = 0;
        let visiblePixels = 0;
        let hiddenPixels = 0;

        for (let colI in this.activeColumns) {
          const col = this.activeColumns[colI];
          ctr += col.size + 1; // separatorWidth == 1px

          if (ctr >= scrollLeft) {
            firstVisibleColI = parseInt(colI);
            visiblePixels = ctr - scrollLeft;
            hiddenPixels = col.size - visiblePixels;
            break
          }
        }

        let targetScrollPos;
        DEBUG && console.log(`ArrowLeft, first visible col is ${firstVisibleColI}, hiddenPixels:${hiddenPixels}, visiblePixels:${visiblePixels}`);
        if (firstVisibleColI === 0) {
          targetScrollPos = 0;
        } else if (hiddenPixels > 5) {
          targetScrollPos = scrollLeft - hiddenPixels;
        } else {
          targetScrollPos = scrollLeft - hiddenPixels - this.activeColumns[firstVisibleColI - 1].size;
        }

        targetScrollPos = targetScrollPos >= 0 ? targetScrollPos : 0;
        DEBUG && console.log(`Scrolling left to: ${targetScrollPos}`)
        this.setHScrollPos(targetScrollPos, false);
        return;
      }

      if (ev.key === "ArrowRight") {

        const scrollLeft = this.$refs.unpinnedData.scrollLeft;
        const pinnedAreaWidth = this.pinnedColumnsWidth;
        const viewWidth = this.$refs.hScroll.offsetWidth - this.scrollBarWidth;

        let ctr = pinnedAreaWidth;

        let lastVisibleColI = this.activeColumns.length - 1;
        let visiblePixels = this.activeColumns[lastVisibleColI];
        let hiddenPixels = 0;


        for (let colI in this.activeColumns) {
          const col = this.activeColumns[colI];
          ctr += col.size + 1; //separator

          if (ctr > scrollLeft + viewWidth) {
            lastVisibleColI = parseInt(colI);
            hiddenPixels = ctr - (scrollLeft + viewWidth); // columnsCount * separatorWidth == 1px
            visiblePixels = col.size - hiddenPixels;
            break
          }
        }

        const maxScroll = this.$refs.unpinnedDataSection.$el.offsetWidth - viewWidth;

        let targetScrollPos;
        DEBUG && console.log(`ArrowRight, last visible col is ${lastVisibleColI}, hiddenPixels:${hiddenPixels}, visiblePixels:${visiblePixels}`);
        if (lastVisibleColI === this.activeColumns.length - 1) {
          targetScrollPos = maxScroll;
        } else if (hiddenPixels > 5) {
          targetScrollPos = scrollLeft + hiddenPixels;
        } else {
          targetScrollPos = scrollLeft + hiddenPixels + this.activeColumns[lastVisibleColI + 1].size;
        }

        targetScrollPos = targetScrollPos >= maxScroll ? maxScroll : targetScrollPos;
        DEBUG && console.log(`Scrolling left to: ${targetScrollPos}`)
        this.setHScrollPos(targetScrollPos, false);
        return;
      }

      if (ev.key === "Home") {
        if (ev.shiftKey) {

        }
        this.focusOnIndex = 0;
        this.updateSelectedRow();
        return;
      }

      if (ev.key === "End") {
        if (ev.shiftKey) {

        }
        this.focusOnIndex = this.postProcessedSource.length - 1;
        this.updateSelectedRow();
        return;
      }

      if (ev.key === "PageUp") {
        if (this.focusOnIndex === -1) {
          this.focusOnIndex = 0;
          this.updateSelectedRow();
          return;
        }
        const pageSize = Math.ceil(this.$refs.unpinnedData.offsetHeight / this.rowHeight);

        if (ev.shiftKey) {

        }
        this.focusOnIndex -= pageSize;
        this.updateSelectedRow();
      } else if (ev.key === "PageDown") {
        if (this.focusOnIndex === -1) {
          this.focusOnIndex = 0;
          this.updateSelectedRow();
          return;
        }

        const pageSize = Math.ceil(this.$refs.unpinnedData.offsetHeight / this.rowHeight);
        if (ev.shiftKey) {

        }
        this.focusOnIndex += pageSize;
        this.updateSelectedRow();
        return;
      }

      if (ev.key === "Delete") {
        if (this.focusOnIndex === -1) {
          return
        }

        this.$emit("delete");
        return;
      }

      if (ev.key === "Escape") {
        this.focusOnIndex = -1;
        //ev.target.blur();
        return;
      }

      DEBUG && console.log(ev);
    },

    resetSelectonAndVScroll() {
      this.focusOnIndex = -1;
      this.updateSelectedRow();
    },

    rowDoubleClick(ev, row) {
      if (this.editOn) {
        return;
      }
      nextTick(() => {
        this.$emit("rowDoubleClick", row);
      });
      DEBUG && console.log(ev);
    },

    scheduleUpdateSource(resetScroll = false) {
      this.resetScroll = resetScroll;
      if (!this.updateSourcesScheduled) {
        this.updateSourcesScheduled = true;
        this.$nextTick(() => {
          this.updateSources();
        });
      }
    },

    updateSources() {
      if (this.isUpdatingSources) {
        return;
      }
      this.isUpdatingSources = true;
      if (!this.streaming && !this.source.dataStream) {
        this.sortNonStream(false);
      } else {
        this.postProcessedSource = this.source;
      }
      const resetScroll = this.resetScroll;
      this.resetScroll = false;

      let hScroll;
      let vScroll;
      if (!resetScroll) {
        hScroll = this.$refs.hScroll.scrollLeft;
        vScroll = this.$refs.vScroll.scrollTop
      }

      DEBUG && console.log(`Updating source; keep scroll: ${!resetScroll} hScroll: ${hScroll}, vScroll: ${vScroll}`);

      this.updateSourcesScheduled = false;
      if (!this.$refs.unpinnedData?.offsetHeight) {
        DEBUG && console.log("Data section size is 0");
        this.isUpdatingSources = false;
        return;
      }

      let requiredRenderers = Math.ceil(this.$refs.unpinnedData.offsetHeight / this.rowHeight) + 1;
      let rowsAdded = false;
      let rowsDeleted = false;

      this.calcVScrollSize();

      if (requiredRenderers > this.postProcessedSource.length) {
        requiredRenderers = this.postProcessedSource.length;
      }

      DEBUG && console.log(`Setting source: source.length: ${this.postProcessedSource.length}`);
      if (!this.postProcessedSource.length) {
        DEBUG && console.log("no data");
      }

      if (this.rows.length > requiredRenderers) {
        this.rows.splice(0, this.rows.length - requiredRenderers);
        DEBUG && console.log("Rendering rows deleted");
        rowsDeleted = true;
      }

      while (this.rows.length < requiredRenderers) {
        this.rows.push({
          uid: nextUid++,
          index: -1,
          flexOrder: -1
        });
        rowsAdded = true;
      }

      if (rowsAdded) {
        DEBUG && console.log("Rendering rows added");
      }

      if (resetScroll || rowsDeleted) {
        const maxI = this.postProcessedSource.length - 1;
        for (let i = 0; i < this.rows.length; i++) {
          const row = this.rows[i];
          row.index = i <= maxI ? i : -1;
          row.flexOrder = i;
          row.data = this.postProcessedSource[i];
          row.cssClass = " " + (row.data?.__row_conf?.cssClass ?? "");
        }
      } else {
        this.setHScrollPos(hScroll);
        this.setVScrollPos(vScroll);
      }

      DEBUG && console.log("Source processing finished");
      this.onVScroll();
      this.onHScroll();
      this.refreshView();

      this.isUpdatingSources = false;
    },

    scheduleInitSize() {
      if (!this.initSizesScheduled) {
        this.initSizesScheduled = true;
        this.$nextTick(() => {
          this.initSizes();
        });
      }
    },

    initSizes() {
      this.initSizesScheduled = false;
      let totalWidth = 0
      for (let col of this.activeColumns) {
        totalWidth += col.size;
      }
      totalWidth += 1 * (this.activeColumns.length);
      //totalWidth +=

      let headerH = this.$refs.headerBody.offsetHeight;
      let pinnedHeaderH = this.$refs.pinnedHeaderBody.offsetHeight;
      const h = headerH > pinnedHeaderH ? headerH : pinnedHeaderH;
      if (h !== 0) {
        this.headerHeight = h;
      }
      DEBUG && console.log(`Initializing header height to ${this.headerHeight}px`);

      let totalPinnedWidth = 0
      for (let col of this.activePinnedColumns) {
        totalPinnedWidth += col.size;
      }
      totalPinnedWidth += 1 * this.activePinnedColumns.length;
      this.pinnedColumnsWidth = totalPinnedWidth;

      this.hScrollSize = totalWidth + totalPinnedWidth + this.scrollBarWidth;
      if (document.querySelector(".activity-top .active [data-test-path='base-grid'] [data-test-path='header-bar']")) {
        const hscroll = document.querySelector(".activity-top .active .v-scroll");
        if (this.hScrollSize < document.querySelector(".activity-top .active [data-test-path='base-grid'] [data-test-path='header-bar']").offsetWidth || hscroll.offsetWidth <= this.scrollBarWidth) {
          this.hScrollSize = totalWidth + totalPinnedWidth;
        }
      }

      this.calcVScrollSize();
      if (this.state && !this.frozen) {
        if (!this.headerHeight) {
          this.headerHeight = this.state.headerHeight;
        }
        DEBUG && console.log(`Unfreezing hScroll: ${this.state.hScroll}, vScroll: ${this.state.vScroll}`);
        this.$nextTick(() => {
          if (this.state) {
            this.setHScrollPos(this.state.hScroll);
            this.setVScrollPos(this.state.vScroll);
            this.state = null;
          } else {
            this.fixSelectedRowVisibility();
          }
          this.onVScroll();
          this.onHScroll();
        });
      } else {
        this.onVScroll();
        this.onHScroll();
      }
      this.scheduleUpdateSource();
    },

    viewScroll(ev) {
      DEBUG && console.log(`Scroll view event: ${ev.deltaX}: ${ev.deltaY}`);
      if (ev.deltaX) {
        let targetScroll = this.$refs.hScroll;
        targetScroll.scroll({top: 0, left: targetScroll.scrollLeft + ev.deltaX, behavior: 'instant'});
      }
      if (ev.deltaY) {
        let targetScroll = this.$refs.vScroll;
        DEBUG && console.log(`Scrolling target to ${targetScroll.scrollTop}`)
        targetScroll.scroll({top: targetScroll.scrollTop + ev.deltaY, left: 0, behavior: 'instant'});
      }
      this.$emit('cancelEdit', true);

    },
    onHScroll(ev = null) {
      this.$emit('cancelEdit', true);
      const scrollLeft = ev?.target?.scrollLeft ?? this.$refs.hScroll?.scrollLeft ?? 0;

      DEBUG && ev && console.log("HScroll event: ", scrollLeft);
      DEBUG && !ev && console.log("Forced HScroll event: ", scrollLeft);

      this.$refs.headerBar.scroll({left: scrollLeft, behavior: 'instant'});
      this.$refs.unpinnedData.scroll({top: 0, left: scrollLeft, behavior: 'instant'});
      this.$refs.unpinnedSummaryRow?.scroll({top: 0, left: scrollLeft, behavior: 'instant'});

      this.$emit('hScroll', scrollLeft);
    },

    firstVisibleIndex() {
      const scrollTop = Math.floor(this.$refs.vScroll?.scrollTop ?? 0);
      const rowHeight = Math.floor(this.rowHeight);
      return Math.floor(scrollTop / rowHeight);
    },

    windowSize() {
      return this.rows.length;
    },

    onTouchStart(event) {
      DEBUG && console.log("Touch start");
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
    },

    onTouchMove(event) {
      event.preventDefault();

      const touchCurrentX = event.touches[0].clientX;
      const touchCurrentY = event.touches[0].clientY;

      const deltaX = this.touchStartX - touchCurrentX;
      const deltaY = this.touchStartY - touchCurrentY;

      this.viewScroll({deltaX, deltaY});

      this.touchStartX = touchCurrentX;
      this.touchStartY = touchCurrentY;
    },

    onVScroll(ev = null) {
      if (ev) {
        ev.stopImmediatePropagation();
        ev.preventDefault(); // Stops default behavior
        ev.stopPropagation(); // Stops bubbling
      }
      if (this.frozen || !this.$refs.unpinnedData?.offsetHeight) {
        return;
      }
      if (this.$refs.unpinnedSummaryRow) {
        this.$refs.unpinnedSummaryRow.scrollTop = 0;
      }
      if (this.$refs.unpinnedData) {
        this.$refs.unpinnedData.scrollTop = 0;
      }
      if (this.$refs.pinnedData) {
        this.$refs.pinnedData.scrollTop = 0;
      }

      this.$emit('cancelEdit', true);

      const scrollTop = Math.floor(ev?.target?.scrollTop ?? this.$refs.vScroll?.scrollTop ?? 0);

      DEBUG && ev && console.log("VScroll event: ", scrollTop);
      DEBUG && !ev && console.log("Forced VScroll event: ", scrollTop);
      const total = Math.floor(this.vScrollSize);
      const rowHeight = Math.floor(this.rowHeight);

      DEBUG && console.log(`scrollTol: ${scrollTop}; total: ${total}; rowHeight: ${rowHeight}`);

      const firstVisibleRowIdx = Math.floor(scrollTop / rowHeight);

      const firstRowVisiblePixels = (firstVisibleRowIdx + 1) * rowHeight - scrollTop;
      this.firstRowHiddenPixels = rowHeight - firstRowVisiblePixels;

      const renderRowsToIndexes = new Map();
      let unsetCtr = -1;
      for (const row of this.rows) {
        if (row.index < 0) {
          row.index = unsetCtr--;
        }
        renderRowsToIndexes.set(row.index, row);
      }

      const maxI = this.postProcessedSource.length - 1;
      const missedIndexes = new Set();
      for (let i = 0; i < this.rows.length; i++) {
        const requiredIndex = firstVisibleRowIdx + i;
        if (renderRowsToIndexes.has(requiredIndex)) {
          const renderRow = renderRowsToIndexes.get(requiredIndex);
          renderRowsToIndexes.delete(requiredIndex);
          renderRow.flexOrder = i;
          renderRow.cssClass = " " + (this.postProcessedSource[renderRow.index]?.__row_conf?.cssClass ?? "");

        } else {
          missedIndexes.add(i);
        }
      }
      for (const i of missedIndexes) {
        const freeRendererKey = renderRowsToIndexes.keys().next().value;
        const freeRenderer = renderRowsToIndexes.get(freeRendererKey);
        renderRowsToIndexes.delete(freeRendererKey);
        freeRenderer.index = firstVisibleRowIdx + i <= maxI ? firstVisibleRowIdx + i : -1;
        freeRenderer.flexOrder = i;
        freeRenderer.data = this.postProcessedSource[freeRenderer.index];
        freeRenderer.cssClass = " " + (this.postProcessedSource[freeRenderer.index]?.__row_conf?.cssClass ?? "")

      }

      this.$emit('vScroll', scrollTop);
      this.$emit('hScroll', scrollTop);


      if (this.$refs.unpinnedData) {
        this.$refs.unpinnedData.scrollTop = 0;
        this.$refs.unpinnedData.scroll({top: 0, behavior: 'instant'});
      }
      this.$nextTick(() => {
        if (this.$refs.unpinnedData.scrollTop) {
          this.$refs.unpinnedData.scrollTop = 0;
          this.$refs.unpinnedData.scroll({top: 0, behavior: 'instant'});

          console.log("XD2");
        }
      });
      return false;
    },

    unmarkSelectionIfOffScreen() {
      if (this.focusOnIndex >= 0) {
        if (!this.postProcessedSource) {
          this.focusOnIndex = -1;
          return
        }
        if (this.postProcessedSource.length - 1 < this.focusOnIndex) {
          this.focusOnIndex = -1;
          return
        }
        if (this.postProcessedSource[this.focusOnIndex].__pending__) {
          for (let row of this.rows) {
            if (row.index === this.focusOnIndex) {
              return;
            }
          }

          this.focusOnIndex = -1;
        }
      }
    },

    fixSelectedRowVisibility() {
      const scrollTop = this.$refs.vScroll?.scrollTop ?? 0;
      const total = Math.floor(this.vScrollSize);
      const window = Math.floor(this.$refs.vScroll.offsetHeight - this.headerHeight);
      const rowHeight = Math.floor(this.rowHeight);
      let firstVisibleRowIdx = Math.floor(scrollTop / rowHeight);
      const firstRowVisiblePixels = (firstVisibleRowIdx + 1) * rowHeight - scrollTop;
      const firstRowHiddenPixels = rowHeight - firstRowVisiblePixels;

      if (firstRowHiddenPixels > 1) {
        firstVisibleRowIdx++;
      }
      if (firstVisibleRowIdx < 0) {
        firstVisibleRowIdx = 0;
      }

      if (this.focusOnIndex < firstVisibleRowIdx) {
        this.setVScrollPos(this.focusOnIndex * this.rowHeight);
        return;
      }

      let lastFullyVisibleRow = Math.floor((scrollTop + window) / rowHeight) - 1;
      if (lastFullyVisibleRow < 0) {
        lastFullyVisibleRow = 0;
      }

      if (this.focusOnIndex > lastFullyVisibleRow) {

        let targetTop = Math.floor((this.focusOnIndex + 1) * rowHeight - window);
        if (targetTop + window > total) {
          targetTop = total - window;
        }
        if (targetTop < 0) {
          targetTop = 0;
        }

        this.setVScrollPos(targetTop);
      }
    },

    setHScrollPos(scrollLeft, smooth = false) {
      this.$refs.hScroll.scrollTo({top: 0, left: scrollLeft, behavior: smooth ? 'smooth' : 'instant'});
    },
    setVScrollPos(scrollTop, smooth = false) {
      DEBUG && console.log(`VScroll set pos to ${scrollTop}`);
      this.$refs.vScroll.scrollTo({top: scrollTop, left: 0, behavior: smooth ? 'smooth' : 'instant'});
    },

    watchPinnedColumns(columns) {
      let watchedCols = [];
      for (let column of columns) {
        if (watchedCols.length >= this.pinnedColumns) {
          break;
        }
        if (column.visible) {
          watchedCols.push(column);
        }
      }
      return watchedCols;
    },

    watchColumns(columns) {
      let skipped = 0;
      let watchedCols = [];
      for (let column of columns) {
        if (column.visible) {
          if (this.pinnedColumns > skipped) {
            skipped++;
            continue;
          }
          watchedCols.push(column);
          if (column.order) {
            this.sortByCol = column;
            this.sortDirection = column.order;
          }
        }
      }
      return watchedCols;
    },

    validateTotalSize() {
      this.refreshView(false);
    },

    onChunkLoaded(offset, windowSize) {
      this.unmarkSelectionIfOffScreen();
      this.refreshRowClasses();
      this.$refs.unpinnedDataSection.onChunkLoaded(offset, windowSize);
      this.$refs.pinnedDataSection.onChunkLoaded(offset, windowSize);
    },

    // headers resize
    colSpacerStartDrag(event) {
      DEBUG && console.log("Header space drag start");

      const element = event.target;
      const colId = element.dataset['colId'] ?? element.parentElement?.dataset['colId'];
      if (!colId) {
        let fallback = element.getAttribute("data-col-id");
        DEBUG && console.log(`Header space drag start - no colId attribute ${fallback}`);
        return;
      }

      const col = this.columns.find(c => c.colId === colId);
      if (!col) {
        DEBUG && console.log("Header space drag start - no col found");
        return;
      }
      if (col.prop == '__meta__') {
        return;
      }

      element.classList.add('headerDragSpacer');

      const offsetX = event.clientX;
      const offsetY = event.clientY;

      this.$refs.root.classList.add("noSelection");
      const startColSize = col.size;

      DEBUG && console.log(`Header space drag start - ${colId} => ${col.name}. col.width: ${col.width}; start point: ${event.clientX}, ${event.clientY}`);

      const onMouseMove = (ev) => {
        const left = ev.clientX - offsetX;
        const top = ev.clientY - offsetY;

        if (left < -startColSize) {
          col.size = 0;
        } else {
          col.size = startColSize + left;
        }

        if (col.size < 10) {
          col.size = 10;
        }

        DEBUG && console.log(`Header space drag - move: x:${left}, y:${top}, col.width => ${col.size}`);
        ev.stopImmediatePropagation();
        this.scheduleInitSize();
        return false;
      };

      const onMouseUp = () => {
        this.isDragging = false;

        DEBUG && console.log(`Header space drag end`);

        element.classList.remove('headerDragSpacer');

        this.$refs.root.classList.remove("noSelection");
        this.$emit("headerResize", col);

        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        this.resizing = false;
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);


      this.isDragging = true;
    },

    // ---
    calcVScrollSize() {
      this.vScrollSize = this.rowHeight * this.postProcessedSource.length;
      DEBUG && console.log(`Calculating rows size: pinnedBottomHeight: ${this.pinnedBottomHeight}; headerHeight: ${this.headerHeight}; rows: ${this.postProcessedSource.length}; areaBaseSize: ${this.vScrollSize}`)
    }
  },

  props: {
    source: {default: () => [], required: false},
    columns: {default: () => [], required: false},
    pinnedBottomSource: {default: () => [], required: false},
    pinnedColumns: {default: 0},
    defaultRowHeight: {default: 48},
    streaming: {default: false},
    activeColId: {default: null},
    multiSelectVisible: {default: false},
    editOn: {default: false},
    eligibleFields: {default: null},
    form: {type: BaseFormConfig},
    context: {default: null},
    streamingEngine: {default: null},
  },

  watch: {
    columns: function (val) {
      DEBUG && console.log("Columns change detected");
      this.activeColumns = this.watchColumns(val);
      this.activePinnedColumns = this.watchPinnedColumns(val);
      this.state = {
        hScroll: this.$refs.hScroll.scrollLeft,
        vScroll: this.$refs.vScroll.scrollTop,
        headerHeight: this.headerHeight
      }

      this.scheduleInitSize();
    },
    source: function (val) {
      this.loading = this.streaming && !val.dataStream;
      DEBUG && console.log(`Source change detected: ${this.source.length}`);
      this.scheduleUpdateSource();
      this.$emit("markReadyToShow")
    },
    loading: function (val) {
      DEBUG && console.log(`Loading: ${val}`);
      if (!val) {
        this.$nextTick(() => {
          this.$refs.unpinnedDataSection?.show();
          this.$refs.pinnedDataSection?.show();
        })
      } else {
        this.$refs.unpinnedDataSection?.hide();
        this.$refs.pinnedDataSection?.hide();
      }
    },
    focusOnIndex: function (val) {
      DEBUG && console.log(`Focus changed: ${this.focusOnIndex}`);

      if (val < 0) {
        this.$emit("rowSelected", null);
      }
    },

    pinnedBottomSource: function (val) {
      if (!val || val.length === 0) {
        return;
      }

      this.activePinedBottomSourceRows = [
        {
          uid: -1,
          index: 0,
          flexOrder: 0,
          data: val[0],
          cssClass: " "
        }
      ]
      this.showSummary = true;

      this.$nextTick(() => {
        this.$refs.unpinnedSummaryRowDataSection?.show();
        this.$refs.unpinnedSummaryRowDataSection?.refreshView();
      })

      if (this.activePinnedColumns.length > 0) {
        this.$nextTick(() => {
          this.$refs.pinnedSummaryRowDataSection?.show();
          this.$refs.pinnedSummaryRowDataSection?.refreshView();
        })
      }
      if (this.pinnedBottomHeight === 0) {
        this.pinnedBottomHeight = this.pinnedBottomSource && this.pinnedBottomSource.length ? this.defaultRowHeight : 0;
      }
    },
  },


  data: function () {
    let watchedColumns = this.watchColumns(this.columns);
    let watchedPinnedColumns = this.watchPinnedColumns(this.columns);

    let sortByCol = null;
    let sortDirection = 'asc';
    for (let c of this.columns) {
      if (c.order) {
        sortDirection = c.order;
        sortByCol = c;
        break;
      }
    }

    return {
      hasLinkFlag: SessionManager.hasFlag(FeatureFlag.ENABLED_GRID_LINKS),
      instanceUid: instanceUid++,
      postProcessedSource: [],
      pinnedColumnsWidth: 0,
      headerHeight: 0,
      touchStartY: 0,
      touchStartX: 0,
      lastScrollTop: 0,
      lastScrollLeft: 0,
      unlockedColsWidth: 0,
      searchVisible: false,
      /**@type ColumnDefinition[]*/
      activeColumns: watchedColumns,
      activePinnedColumns: watchedPinnedColumns,
      pinnedBottomHeight: this.pinnedBottomSource && this.pinnedBottomSource.length ? this.defaultRowHeight : 0,
      activePinedBottomSourceRows: [],
      rows: [],
      rowHeight: this.defaultRowHeight,
      dataRowsNumber: 0,
      displayedRowsNumber: 0,

      vScrollBarVisible: true,
      showSummary: false,
      hScrollBarVisible: true,

      hScrollSize: 1,
      vScrollSize: 1,
      scrollBarHeight: 0,
      scrollBarWidth: 0,
      firstRowHiddenPixels: 0,

      loading: true,
      focusOnIndex: -1,
      resizing: false,
      isUpdatingSources: false,
      isRefreshingView: false,

      sortByCol,
      sortDirection
    }
  }
}
</script>

<style>
div.draggableMountPoint {
  position: relative;
  width: 0;
  height: 0;
  user-select: none;
}

.noSelection {
  user-select: none;
}
</style>